import { m } from "framer-motion";
import Image from "next/image";
import { Empty as Icon_Empty } from "@/components/customer/icons/Empty";
import { GrowChat as Icon_GrowChat } from "@/components/customer/icons/GrowChat";
import { GrowChatGmeet as Icon_GrowChatGmeet } from "@/components/customer/icons/GrowChatGmeet";
import { GrowChatWhatsapp as Icon_GrowChatWhatsapp } from "@/components/customer/icons/GrowChatWhatsapp";
import { GrowGMAIL as Icon_GrowGMAIL } from "@/components/customer/icons/GrowGMAIL";
import { GrowNotes as Icon_GrowNotes } from "@/components/customer/icons/GrowNotes";
import { GrowPhone as Icon_GrowPhone } from "@/components/customer/icons/GrowPhone";
const SvgIcons = { Empty: Icon_Empty, GrowChat: Icon_GrowChat, GrowChatGmeet: Icon_GrowChatGmeet, GrowChatWhatsapp: Icon_GrowChatWhatsapp, GrowGMAIL: Icon_GrowGMAIL, GrowNotes: Icon_GrowNotes, GrowPhone: Icon_GrowPhone };
import growGroup from '../../images/growShootGroup.webp';

const RotatingSocialIcons: React.FC = () => {
  // Inner circle icons (4 icons)
  const innerIcons = [
    { Icon: SvgIcons.GrowChatGmeet },
    { Icon: SvgIcons.GrowChatWhatsapp },
    { Icon: SvgIcons.Empty },
    { Icon: SvgIcons.Empty },
  ];
  const innerIcons2 = [
    { Icon: SvgIcons.GrowChat },
    { Icon: SvgIcons.GrowNotes },
    { Icon: SvgIcons.Empty },
    { Icon: SvgIcons.Empty },
  ];
  const innerIcons3 = [
    { Icon: SvgIcons.GrowGMAIL },
    { Icon: SvgIcons.GrowPhone },
    { Icon: SvgIcons.Empty },
    { Icon: SvgIcons.Empty },
  ];
  const innerIcons4 = [
    { Icon: SvgIcons.Empty },
    { Icon: SvgIcons.GrowPhone },
    { Icon: SvgIcons.Empty },
    { Icon: SvgIcons.Empty },
  ];

  // Animation duration for the rotating frame
  const rotationDuration = 20;

  // Stagger delay for one-by-one appearance
  const staggerDelay = 0.5; // Delay between each icon's appearance in seconds

  return (
    <div className="flex items-end justify-end">
      <div className="w-[700px] h-[350px] md:h-[700px] mx-auto relative">
        {/* Center Logo/Avatar */}
        <div className="absolute inset-0 bottom-0 flex items-center justify-center z-10">
          <Image
            src={growGroup}
            className="w-full lg:w-[750px] z-50 relative h-full lg:h-[750px] object-contain"
            alt="growGroup"
          />
          <div
            className="
              w-full md:w-[750px]
              h-[175px] md:h-[450px]
              rounded-[20px] rounded-b-none md:rounded-[1143px]
              bg-[#102358]
              absolute bottom-4 md:-bottom-[60px] left-1/2 -translate-x-1/2
              blur-[15px] md:blur-[60px]
              flex-shrink-0
            "
          />
        </div>

        {/* Rotating Frame for Inner Circle 1 */}
        <m.div
          className="absolute inset-0"
          animate={{ rotate: -360 }}
          transition={{
            duration: rotationDuration,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          }}
        >
          {innerIcons.map((item, index) => {
            const angle = index * (360 / innerIcons.length) * (Math.PI / 180);
            const radius = 220;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            return (
              <m.div
                key={index}
                className="absolute flex items-center justify-center"
                style={{
                  left: `calc(50% + ${x}px - 24px)`,
                  top: `calc(50% + ${y}px - 30px)`,
                  width: "10px",
                  height: "10px",
                }}
                initial={{ opacity: 0 }}
                animate={{ 
                  opacity: 1,
                  rotate: 360 
                }}
                transition={{
                  opacity: { 
                    delay: index * staggerDelay, 
                    duration: 0.5 
                  },
                  rotate: {
                    duration: rotationDuration,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "linear",
                  },
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
                >
                  <item.Icon />
                </div>
              </m.div>
            );
          })}
        </m.div>

        {/* Rotating Frame for Inner Circle 2 */}
        <m.div
          className="absolute inset-0"
          animate={{ rotate: -360 }}
          transition={{
            duration: rotationDuration,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          }}
        >
          {innerIcons2.map((item, index) => {
            const angle = index * (360 / innerIcons2.length) * (Math.PI / 180);
            const radius = 150;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            return (
              <m.div
                key={index}
                className="absolute flex items-center justify-center"
                style={{
                  left: `calc(50% + ${x}px - 24px)`,
                  top: `calc(50% + ${y}px - 24px)`,
                  width: "300px",
                  height: "300px",
                }}
                initial={{ opacity: 0 }}
                animate={{ 
                  opacity: 1,
                  rotate: 360 
                }}
                transition={{
                  opacity: { 
                    delay: (index + innerIcons.length) * staggerDelay, 
                    duration: 0.5 
                  },
                  rotate: {
                    duration: rotationDuration,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "linear",
                  },
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
                >
                  <item.Icon />
                </div>
              </m.div>
            );
          })}
        </m.div>

        {/* Rotating Frame for Inner Circle 3 */}
        <m.div
          className="absolute inset-0"
          animate={{ rotate: -360 }}
          transition={{
            duration: rotationDuration,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          }}
        >
          {innerIcons3.map((item, index) => {
            const angle = index * (360 / innerIcons3.length) * (Math.PI / 180);
            const radius = 250;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            return (
              <m.div
                key={index}
                className="absolute flex items-center justify-center"
                style={{
                  left: `calc(50% + ${x}px - 24px)`,
                  top: `calc(50% + ${y}px - 14px)`,
                  width: "150px",
                  height: "10px",
                }}
                initial={{ opacity: 0 }}
                animate={{ 
                  opacity: 1,
                  rotate: 360 
                }}
                transition={{
                  opacity: { 
                    delay: (index + innerIcons.length + innerIcons2.length) * staggerDelay, 
                    duration: 0.5 
                  },
                  rotate: {
                    duration: rotationDuration,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "linear",
                  },
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
                >
                  <item.Icon />
                </div>
              </m.div>
            );
          })}
        </m.div>

        <m.div
          className="absolute inset-0"
          animate={{ rotate: -360 }}
          transition={{
            duration: rotationDuration,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          }}
        >
          {innerIcons4.map((item, index) => {
            const angle = index * (460 / innerIcons3.length) * (Math.PI / 180);
            const radius = 300;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            return (
              <m.div
                key={index}
                className="absolute flex items-center justify-center"
                style={{
                  left: `calc(50% + ${x}px - 24px)`,
                  top: `calc(50% + ${y}px - 1px)`,
                  width: "1px",
                  height: "1px",
                }}
                initial={{ opacity: 0 }}
                animate={{ 
                  opacity: 1,
                  rotate: 360 
                }}
                transition={{
                  opacity: { 
                    delay: (index + innerIcons.length + innerIcons2.length) * staggerDelay, 
                    duration: 0.5 
                  },
                  rotate: {
                    duration: rotationDuration,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "linear",
                  },
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
                >
                  <item.Icon />
                </div>
              </m.div>
            );
          })}
        </m.div>

        {/* Empty motion.div for consistency with original code */}
        <m.div
          className="absolute inset-0"
          animate={{ rotate: -360 }}
          transition={{
            duration: rotationDuration,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          }}
        ></m.div>


        

        {/* Decorative Circles */}
        <div
          className="absolute border border-blue-300/20 rounded-full"
          style={{
            width: "600px",
            height: "600px",
            left: "calc(50% - 300px)",
            top: "calc(50% - 300px)",
          }}
        ></div>
        <div
          className="absolute border border-blue-300/20 rounded-full"
          style={{
            width: "500px",
            height: "500px",
            left: "calc(50% - 250px)",
            top: "calc(50% - 250px)",
          }}
        ></div>
        <div
          className="absolute border border-blue-300/10 rounded-full"
          style={{
            width: "400px",
            height: "400px",
            left: "calc(50% - 200px)",
            top: "calc(50% - 200px)",
          }}
        ></div>

        {/* Floating Particles */}
        {[...Array(8)].map((_, i) => (
          <m.div
            key={i}
            className="absolute w-2 h-2 bg-blue-400/30 rounded-full"
            style={{
              left: `${15 + Math.random() * 70}%`,
              top: `${15 + Math.random() * 70}%`,
            }}
            animate={{
              y: [-15, 15, -15],
              opacity: [0.3, 0.8, 0.3],
            }}
            transition={{
              duration: 3 + Math.random() * 3,
              repeat: Number.POSITIVE_INFINITY,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default RotatingSocialIcons;